import { makeStyles, Dialog } from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import AddIcon from '@material-ui/icons/Add';
import * as React from 'react';

import {  withStyles } from '@material-ui/core'
import MuiButton from '@material-ui/core/Button';
import { HttpClient } from "../../../utils/requests";

import { Form, useFormState } from 'react-final-form';
import { Field } from 'react-final-form'

import arrayMutators from 'final-form-arrays';
import Save from '@material-ui/icons/Save';
import MuiTextField from '@material-ui/core/TextField'
import {  useNotify, useRefresh } from 'react-admin';

import { SERVER } from '../../../constants';
// import { AUTH_TYPES } from '../../../auth/authConstants';


const TextInput = withStyles({
    root: {
        margin: '16px 0px'
    }
})(MuiTextField);

const defaultSubscription = {
    submitting: true,
    pristine: true,
    valid: true,
    invalid: true,
};
const useStyles = makeStyles({
    dialog: {
      position: 'absolute',
      right: 55,
      top: 95
    }
  });
  
export const CustomerCreateCommentButton = (props) => {
    const refresh = useRefresh();

    const [open, setOpen] = React.useState(false); // Controls modal
    // const [create, { loading }] = useCreate('customer'); // Access dataProvider API call
    const notify = useNotify(); // Initialize notify object to send notification to dashboard
    // const form = useForm(); // Gains access to the parent form
    const classes = useStyles();

    // const [contect , setcustomer] = setState(props.customer);
   
  
    const handleSubmit = async (values, props) => {
        // const { push } = this.props;
        HttpClient(SERVER + `/admin/customer/comment`, {
            method: "PUT",
            body: JSON.stringify(values),
        })
            .then(() => {
                notify('کامنت ثبت شد');
                refresh();
                setOpen(false)

            })
            .catch((e) => {
                notify('Error: comment not approved', 'warning')
            });

    };


    return (
        <>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="form-dialog-title"
                classes={{
                    paper: classes.dialog
                  }}
            >
                <DialogTitle id="form-dialog-title"> ارسال نظر </DialogTitle>
                <DialogContent>
                    <Form
                        initialValues={{ customerId: props?.customer?.customerId}}
                        onSubmit={handleSubmit}
                        mutators={{ ...arrayMutators }} // necessary for ArrayInput
                        subscription={defaultSubscription} // do not redraw entire form each time one field changes
                        // key={} // support for refresh button
                        keepDirtyOnReinitialize
                        render={({ handleSubmit, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <Field name="comment">
                                    {props => (
                                        <div>
                                            <TextInput
                                                label={"کامنت"}
                                                multiline rows={5}
                                                variant="outlined"
                                                name={props.input.name}
                                                setValue={props.input.value}
                                                onChange={props.input.onChange}
                                            />
                                        </div>
                                    )}
                                </Field>
                                <FieldWithDefault name="customerId">
                                 {/* <Field name="customerId" {...props} > */}
                                    {props => (
                                        <div>

                                            {/* <TextInput

                                                label={"customerId"}
                                                disabled
                                                variant="outlined"
                                                name="customerId"
                                                // value={props.customer.customerId}
                                                // defaultValue={props.customer.customerId}
                                                // initialValue={props.customer.customerId}
                                                touched
                                                onChange={props.input.onChange}

                                            /> */}
                                        </div>
                                    )}
                                </FieldWithDefault> 

                                <br />
                                {/* <Field name="name" {...props}>
                                    {props => (
                                        <div>

                                            <TextInput
                                                label={""}
                                                disabled
                                                variant="outlined"
                                                name="name"
                                                value={props.customer.name}
                                                onChange={props.input.onChange}

                                            />
                                        </div>
                                    )}
                                </Field> */}

                                <br />



                                <Button variant="outlined" color="primary" customerName={props.customer.name} type="submit" disabled={submitting || pristine}>
                                    <Save style={{ marginRight: '8px' }} /> ارسال
                                </Button>
                            </form>
                        )}
                    />

                </DialogContent>
            </Dialog>
            <Button variant="outlined" color="primary" aria-label="create" onClick={() => setOpen(true)}>
                <AddIcon style={{ marginRight: '4px' }} /> ارسال نظر
            </Button>
        </>
    )
}
const Button = withStyles({
    root: {
        margin: '16px 0px'
    }
})(MuiButton);


const FieldWithDefault = ({ unsetInitialValue, ...props }) => {
  const { initialValues } = useFormState({ initialValues: true });
  const initialValue = props.name in initialValues
    ? initialValues[props.name]
    : unsetInitialValue;

  return <Field initialValue={initialValue} {...props} />;
}
